import Radio from 'backbone.radio';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import _ from 'underscore';
import DialogInterface from '@/interfaces/dialog';
import PaginatedMenuView from '@/views/paginated_menu_view';
import DeploymentList from '@/views/modules/selectable_pre_deployment_list';
import template from '@/../templates/production-device-group-settings.hbs';
import strings_specific from 'amdi18n-loader!@/nls/production_device_group_settings';
import strings_common from 'amdi18n-loader!@/nls/common';

    var strings = _.extend({}, strings_common, strings_specific);
    var MAX_DESCRIPTION_LENGTH = 300;
    var MAX_NAME_LENGTH = 100;

    var globalCh = Backbone.Radio.channel('global');

    function human_readable_type(type) {
        if (type === 'pre_production_devicegroup') {
            return 'Test Production Device Group';
        }
        return 'Production Device Group';
    }

    function human_readable_deployment_types(type) {
        if (type === 'pre_production_devicegroup') {
            return 'Development and Test Production Device Group Deployments';
        }
        return 'Development, Test Production and Production Device Group Promoted Deployments';
    }

    function perm_check(active, primary, type){
        if ( type === 'production_devicegroup' && active.permits(primary, 'update_production_vars') ) {
            return true;
        } else if ( type === 'pre_production_devicegroup' && active.permits(primary, 'update_pre_production_vars') ){
            return true;
        }
        return false;
    }

    var post_webhook = function (devicegroup, webhook_url, event, content_type) {
        var apiCh = Radio.channel('api');
        var webhooks = apiCh.request('webhook');
        return new Promise(function (resolve, reject) {
            webhooks.create({
                type: 'webhook',
                attributes: {
                    event: event,
                    content_type: content_type,
                    url: webhook_url,
                },
                relationships: {
                    devicegroup: {
                        id: devicegroup.id,
                        type: devicegroup.type
                    }
                }
            }, {
                    wait: true,
                    success: resolve,
                    error: function(webhook, response){
                        reject(response);
                    }
                });
        });
    };

    var update_webhook = function (webhook, url, type) {
        return new Promise(function (resolve, reject) {
            webhook.save({
                data: {
                    type: 'webhook',
                    id: webhook.id,
                    attributes: {
                        url: url,
                        content_type: type
                    }
                }
            },
                {
                    patch: true,
                    error: function(webhook, response){
                        reject(response);
                    }
                })
                .then(resolve);
        });
    };

    const view = Marionette.View.extend(DialogInterface).extend({
        template: Handlebars.compile(template),
        blessing_webhook: null,
        blinkup_webhook: null,
        changed: {
            load_code_after_blessing: false,
            blessing_url: false,
            blinkup_url: false
        },
        on_success: function () {
            this.closeDialog();
        },
        initialize: function (options) {
            if ( this.getOption('devicegroup') ){
                this.model = this.getOption('devicegroup');
                this.owner = this.model.rel.get('owner');
                this.dialog_type = 'settings';
            } else if ( this.getOption('model') ) {
                this.owner = this.model.rel.get('owner');
                this.dialog_type = 'settings';
            } else {
                this.owner = Radio.request('global', 'active_account');
                this.dialog_type = 'create';
            }
            this.destroyOnClose();
            this.focusFirstInput();
            _.bindAll(this, 'handle_success', 'handle_error');
        },
        ui: {
            blessing_options: 'input[name=blessing-options]',
            blessing_option: 'input[name=blessing-options]:checked',
            blessing_url: '#blessing-url',
            blinkup_url: '#blinkup-url',
            blessing_type: '#blessing-type',
            blinkup_type: '#blinkup-type',
            code_list_label: '.code-list-label',
            submit: '.btn.submit',
            tooltips: '[data-toggle="tooltip"]',
            blessing_content: '.blessing',
            blinkup_content: '.blinkup',
            delete_webhook: '.delete-webhook',
            inputs: 'input',
            forms: '.form-control',
            delete_blinkup_webhook: '.delete-blinkup-webhook',
            delete_blessing_webhook: '.delete-blessing-webhook',
            name: '.form-control.name',
            description: '.form-control.description',
            name_length_counter: '.name-counter',
            description_length_counter: '.description-counter',
            region_dropdown: '.region-dropdown',
            region_label: '.region-label',
            totp_form: '.totp-form',
            totp_input: '.totp-input',
            env_vars: '.environment-variables',
            env_vars_textarea: '.environment-variables textarea',
            blank_deployment: '.blank-deployment'
        },
        regions: {
            code_list: '.code-list',
            pagination_controls: '.pagination',
            region_menu: '@ui.region_dropdown',
        },
        templateContext: function () {
            const globalCh = Radio.channel('global');
            var active = globalCh.request('active_account');
            var primary = globalCh.request('primary_account');
            let is_create = false;
            let dialog_title;
            let name = undefined;
            let type = undefined;
            if ( this.model ){
                dialog_title = this.model.type === 'pre_production_devicegroup' 
                    ? strings.pre_production_devicegroup_settings_title
                    : strings.production_devicegroup_settings_title;
                name = this.model.get('name');
                type = this.model.type;
            } else {
                dialog_title = this.getOption('type') === 'pre_production_devicegroup' 
                    ? strings.pre_production_devicegroup_create_title
                    : strings.production_devicegroup_create_title;
                is_create = true;
                type = this.getOption('type');
            }

            let env_vars = null;
            let env_vars_keys = null;
            let edit_env_vars = false;
            let show_env_vars_keys = false;
            
            if ( this.model && this.model.get('env_vars') ) { 
                env_vars = JSON.stringify(this.model.get('env_vars'), null, 4);
            }
            if ( perm_check(active, primary, type) ) {
                edit_env_vars = true;
            } else {
                show_env_vars_keys = true;
                if ( this.model && this.model.get('env_vars') ) {
                    env_vars_keys = Object.keys(this.model.get('env_vars'));
                }

            }
            if ( !env_vars_keys ) env_vars_keys = "no variables";

            return _.extend({}, strings, {
                name: name,
                title: dialog_title,
                type: human_readable_type(this.options.type),
                deployment_types: human_readable_deployment_types(this.options.type),
                is_create: is_create,
                show_env_vars_keys: show_env_vars_keys,
                edit_env_vars: edit_env_vars,
                env_vars: env_vars,
                env_vars_keys: env_vars_keys
            });
        },
        onRender: function () {
            this.ui.tooltips.tooltip({
                placement: 'bottom',
                title: `<div>${strings.tooltip_1}</div>
                        <div><strong>${strings.blessing}</strong>${strings.tooltip_2}</div>
                        <div><strong>${strings.blinkup}</strong>${strings.tooltip_3}</div>`,
                html: true,
                template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
            });

            if ( !this.mfa_required() ) this.ui.totp_form.hide();
            if ( this.model ) {
                if (_.has(this.model.attributes, 'load_code_after_blessing')) {
                    if (this.model.attributes.load_code_after_blessing === true) {
                        this.ui.blessing_options.filter(function () { return this.value == 'blessing'; }).prop('checked', true);
                        this.blessing_option = 'blessing';
                    } else {
                        this.ui.blessing_options.filter(function () { return this.value == 'blinkup'; }).prop('checked', true);
                        this.blessing_option = 'blinkup';
                    }
                }
                this.ui.region_label.hide();
                this.ui.code_list_label.hide();
                this.ui.name.val( this.model.get('name') );
                this.ui.description.val( this.model.get('description') );
                this.validate();
                var webhooks = this.model.webhooks;
                webhooks.fetch().then(function () {
                    webhooks.forEach(function (webhook) {
                        var devicegroup = webhook.rel.get('devicegroup');
                        if (devicegroup.id === this.model.id) {
                            if (webhook.get('event') === 'blessing') {
                                this.blessing_webhook = webhook;
                                this.ui.blessing_url.val(webhook.get('url'));
                                this.ui.blessing_type.val(webhook.get('content_type'));
                                this.ui.delete_blessing_webhook.removeClass('hidden');
                            } else if (webhook.get('event') === 'blinkup') {
                                this.blinkup_webhook = webhook;
                                this.ui.blinkup_url.val(webhook.get('url'));
                                this.ui.blinkup_type.val(webhook.get('content_type'));
                                this.ui.delete_blinkup_webhook.removeClass('hidden');
                            }
                        }
                    }.bind(this));
                }.bind(this));
            } else {
                this.maybeShowRegionsMenu();
                this.ui.blessing_options.filter(function () { return this.value == 'blessing'; }).prop('checked', true);
                this.blessing_option = 'blessing';
                this.showChildView('code_list', new DeploymentList({
                    collection: this.options.deployments,
                    product: this.options.product,
                    type: this.options.type
                }));
                this.showChildView('pagination_controls', this.options.pagination_controls);
            }
        },
        events: {
            'click @ui.submit': function (e) {
                this.submit(e);
            },
            'click @ui.blessing_option': function (e) {
                if (e.target.value === 'blessing') {
                    this.blessing_option = 'blessing';
                } else {
                    this.blessing_option = 'blinkup';
                }
            },
            'click @ui.delete_webhook': function (e) {
                this.delete_webhook(e.target.dataset.event)
                    .then(function (response) {
                        DialogInterface.showAlert.call(this, 'success', 'Successfully deleted ' + response);
                        if (response === 'blinkup webhook') {
                            this.changed.blinkup_url = false;
                        }
                        if (response === 'blessing webhook') {
                            this.changed.blessing_url = false;
                        }
                        if (!_.contains(this.changed, true)) {
                            if (this.ui.name.val()) {
                                this.ui.submit.prop('disabled', false);
                            }
                        }
                    }.bind(this))
                    .catch(this.handle_error);
            },
            'keyup': 'validate',
            'paste': 'validate',
            'change': 'validate',
            'mouseup': 'validate',
            'choose': 'validate',
            'click @ui.blank_deployment': 'blank_deployment'
        },
        childViewEvents: {
            'choose:deployment': 'chooseDeployment',
            'page': function (filter) {
                var list_view = this.getRegion('code_list').currentView;
                list_view.setFilter(filter);
            }
        },
        validate: function() {
            if ( !this.validate_description()
                    || !this.validate_name()
                    || !this.validate_deployment()
                    || !this.validate_totp()
            ){
                this.ui.submit.prop('disabled', true);
                return false;
            }

            this.ui.submit.prop('disabled', false);
            return true;
        },
        validate_deployment: function () {
            if ( this.deployment || this.model ) return true;
            return false;
        },
        validate_description: function () {
            this.check_validation(
                this.ui.description,
                MAX_DESCRIPTION_LENGTH,
                this.ui.description_length_counter
            );
            if ( this.ui.description.val() ) return true;
            // description is not required, but we still need to check the length
            return true;
        },
        validate_name: function () {
            this.check_validation(
                this.ui.name,
                MAX_NAME_LENGTH,
                this.ui.name_length_counter
            );
            if ( this.ui.name.val() ) return true;
            return false;
        },
        validate_totp: function () {
            if ( this.mfa_required() && this.ui.totp_input.val().length < 6 ) {
                return false;
            }
            return true;
        },
        delete_webhook: function (event_type) {
            return new Promise(function (resolve, reject) {
                if (this[event_type + '_webhook']) {
                    if (event_type === 'blessing') {
                        this.ui.blessing_url.val('');
                        this.blessing_webhook.destroy()
                            .then(function () {
                                this.blessing_webhook = null;
                                resolve('blessing webhook');
                            }.bind(this))
                            .fail(reject);
                    } else if (event_type === 'blinkup') {
                        this.ui.blinkup_url.val('');
                        this.blinkup_webhook.destroy()
                            .then(function () {
                                this.blinkup_webhook = null;
                                resolve('blinkup webhook');
                            }.bind(this))
                            .fail(reject);
                    }
                } else {
                    reject('Cannot delete nonexistent webhook');
                }
            }.bind(this));
        },
        submit: function (e) {
            if (e) {
                e.preventDefault();
                if (e.target.classList.contains('disabled')) {
                    return;
                }

            }
            this.hideAlert();

            let load_code_after_blessing,
                blessing_url,
                blinkup_url,
                blessing_type,
                blinkup_type,
                production_devicegroup,
                name,
                description,
                region;
            load_code_after_blessing = this.blessing_option === 'blessing';
            blessing_url = this.ui.blessing_url.val().trim();
            blinkup_url = this.ui.blinkup_url.val().trim();
            blessing_type = this.ui.blessing_type.val();
            blinkup_type = this.ui.blinkup_type.val();
            production_devicegroup = this.model;
            name = this.ui.name.val().trim();
            description = this.ui.description.val().trim();

           let env_vars_string = this.ui.env_vars_textarea.val();
           let env_vars = null;
           try {
               env_vars = JSON.parse(env_vars_string);
           } catch ( e ) {
                if ( env_vars_string && env_vars_string.length > 0 ) {
                    let error = {
                        responseJSON : {
                            errors: [
                                { detail: e }
                            ]
                        }
                    };
                    this.handle_error(error);
                    return;
                }
            }

            var calls = [];

            if ( !this.model ) {
                this.create(name, description, load_code_after_blessing, region, env_vars);
                return;
            }

            calls.push(this.update(name, description, load_code_after_blessing, env_vars));


            if (this.blinkup_webhook && blinkup_url) {
                calls.push(update_webhook(this.blinkup_webhook, blinkup_url, blinkup_type));
            } else if (blinkup_url) {
                calls.push(post_webhook(production_devicegroup, blinkup_url, 'blinkup', blinkup_type));
            } else if (this.blinkup_webhook && !(blinkup_url)) {
                calls.push(this.delete_webhook('blinkup'));
            }

            if (this.blessing_webhook && blessing_url) {
                calls.push(update_webhook(this.blessing_webhook, blessing_url, blessing_type));
            } else if (blessing_url) {
                calls.push(post_webhook(production_devicegroup, blessing_url, 'blessing', blessing_type));
            } else if (this.blessing_webhook && !(blessing_url)) {
                calls.push(this.delete_webhook('blessing'));
            }

            calls.forEach( call => { call.catch(error => { return error; }); } );


            Promise.all(calls).then(this.handle_success).catch(this.handle_error);
        },
        update: function(name, description, load_code_after_blessing, env_vars) {
            let active = globalCh.request('active_account');
            let primary = globalCh.request('primary_account');

            let attributes = {
                name: name,
                description: description,
                load_code_after_blessing: load_code_after_blessing,
            };
            if ( perm_check(active, primary, this.model.type) ) {
                attributes.env_vars = env_vars;
            }
            return this.model.save({
                data: {
                    type: this.model.type,
                    id: this.model.id,
                    attributes: attributes
                }
            },
            {
                patch: true,
                wait: true
            });
        },
        create: function (name, description, load_code_after_blessing, region, env_vars) {
            var devicegroups = Radio.request('api', 'production_devicegroup');
            var product = this.options.product;
            var cloud_regions = Radio.request('api', 'cloud_regions');
            var selected_region = null;
            var region_menu = this.getRegion('region_menu');
            let active = globalCh.request('active_account');
            let primary = globalCh.request('primary_account');

            if (cloud_regions && cloud_regions.length > 0) {
                selected_region = region_menu.currentView.selected_child;
            }
           
            var opts = {
                name: name,
                type: this.getOption('type') || devicegroups.TYPES_MAP.production,
                description: description,
            };

            if ( perm_check(active, primary, opts.type) ) {
                opts.env_vars = env_vars;
            }

            if (cloud_regions && cloud_regions.length > 0 && selected_region && selected_region.get('name') != 'Default' ) {
                opts.region = selected_region.get('name');
            } 
                
            return devicegroups.create(opts,
            {
                product: product,
                wait: true,
                success: function(model, response){
                    this.model = model;
                    if ( this.deployment.get('sha') ) {
                        this.deploy_to_new_production_devicegroup(model);
                    } else {
                        this.submit();
                    }
                }.bind(this),
                error: function (model, err) {
                    this.handle_error(err);
                }.bind(this),
            });
        },
        
        deploy_to_new_production_devicegroup: function(new_production_devicegroup) {
            var totp = this.ui.totp_input.val();
            var headers = {};
            if ( this.mfa_required() ) {
                headers = {
                    'x-electricimp-otp-token': totp
                };
            }
            var options = {
                type: this.deployment.type,
                attributes: {
                    description: this.deployment.get('description'),
                    sha: this.deployment.get('sha'),
                },
                relationships: {
                    devicegroup: new_production_devicegroup.toReference(),
                }
            };

            this.options.deployments.create(
                options,
                {
                merge: true,
                // Without wait: true, ID is undefined 
                wait: true,
                headers: headers,
                success: function(model, response){
                    this.submit();
                }.bind(this),
                error: function(model, err) {
                    this.handle_error(err);
                    new_production_devicegroup.destroy();
                    this.model = null;
                }.bind(this),
            });
        },
        maybeShowRegionsMenu: function() {
            this.ui.region_label.hide();
            if (this.getOption('show_regions') === false) {
                return;
            }
            var cloud_regions = Radio.request('api', 'cloud_regions');
            var cloud_collection;
            var view_opts;
            var view;
            if ( cloud_regions && cloud_regions.length > 0) {
                this.ui.region_label.show();
                cloud_collection = new Backbone.Collection();
                // add assumed "default" region
                cloud_collection.add(new Backbone.Model({id: 'Default', name: 'Default'}));
                _.each(cloud_regions, function(r) { cloud_collection.add(new Backbone.Model({id: r, name: r})); });
                view_opts = {
                    title: 'Choose a Region',
                    collection: cloud_collection,
                    childView: Marionette.View,
                    no_link: true
                };
                view = new PaginatedMenuView(view_opts);
                this.showChildView('region_menu', view);
            }
        },
        chooseDeployment: function (deployment) {
            this.deployment = deployment;
            this.validate();
        },
        blank_deployment: function() {
            let deployment = new Backbone.Model(
                {
                    agent_code: '',
                    device_code: ''
                }
            );
            this.chooseDeployment(deployment);
        },
        // boolean variable if mfa is required for creating production deployments
        mfa_required: function() {
            if ( this.dialog_type === 'settings' ) return false;
            return this.options.product.rel.get('owner').get('deployment_mfa_required') && this.options.type === 'production_devicegroup';
        },
        handle_error: function (err) {
            if (err.responseJSON) {
                if (err.responseJSON.errors[0].code === 'VX015') {
                    let detail = err.responseJSON.errors[0].detail;
                    if (typeof detail === 'object' && detail.message) detail = detail.message; 
                    detail = detail +  ' --- You have entered an invalid URL — please check your webhook settings. The expected format is "https://www.example.com"';
                    err.responseJSON.errors[0].detail = detail;
                }
            }
            DialogInterface.showAlert.call(this, 'alert-danger', err);
        },
        handle_success: function (model, response, options) {
            this.closeDialog();
            Radio.request('alerts', 'showAlert', {
                message: "Successfully updated settings of " + this.model.get('name'),
                messageType: 'success'
            });
        }
    });
    export default view;

